import BasketNavSFC from "./BasketNav.vue";
export const BasketNav = BasketNavSFC;
